import useSWR from "swr";
import { Tab } from ".";
import { customFetcher, notify } from "../../../utils";
import { ActivationCodes, AppSettings } from "../../../globals/interfaces";
import VirtualTable from "../../../components/custom/VirtualTable";
import ModalActivate from "./ModalActivate";
import useModal from "../../../customHooks/useModal";
import { useState } from "react";
import ActivationCodeModal from "./ModalActivate";
import apiClient from "../../../apiClient";
import useUser from "../../../customHooks/useUser";

export default function Pending({
    activeTab
}: {
    activeTab: Tab;
}) {

    const { user } = useUser();
    const key = activeTab === 'pending' ? '/display-activation/pending' : null;
    const {
        data,
        mutate
    } = useSWR(key, customFetcher<ActivationCodes>, {
        refreshInterval: 5000,
        fallbackData: []
    });

    const { modal, setModal } = useModal();
    const [guid, setGuid] = useState<string>();
    const selectedItem = data.find(item => item.guid === guid);

    const handleStartActivation = (guid: string) => {
        setGuid(guid);
        setModal(true);
    }

    const activateCode = async (code: string, settings: AppSettings, _type: string) => {
        if (code !== selectedItem?.code) return;

        try {
            await apiClient.post(`/display-activation/activate`, {
                code,
                userId: user.s_email,
                settings,
                type: _type === 'kiosk' ? 'kiosk-client' : 'displays-client'
            });
            mutate();
            notify('Activated');
        } catch (err) {
            notify(err, 'error');
        }
    }

    return (
        <div>
            <VirtualTable<ActivationCodes>
                data={data}
                mapping={[{
                    name: 'Device ID',
                    value: 'device_id',
                    customWidth: 300
                }, {
                    name: 'Device Info.',
                    value: 'device_info'
                }, {
                    name: 'Created',
                    value: 'created_at',
                    datetime: true
                }, {
                    name: 'Expires',
                    value: 'expires_at',
                    datetime: true
                }]}
                handleClick={(item: ActivationCodes) => handleStartActivation(item.guid)}
            />
            <ActivationCodeModal
                modal={modal}
                setModal={setModal}
                selectedItem={selectedItem}
                activateCode={activateCode}
            />
        </div>
    );
}